import React, { Component } from 'react'
import Highlighter from 'react-highlight-words'
import * as JsSearch from 'js-search'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import { SectionTitle } from '../../../../components'

import './style.scss'

import data from './data.json'
import icons from './icons.json'

import downloadIcon from '../../../../images/download-icon.png'
import codeIcon from '../../../../images/code-icon.png'

class Iconography extends Component {
  state = {
    index: icons.icons,
    search: [],
    searchResults: [],
    isLoading: true,
    isError: false,
    searchQuery: '',
    searching: false,
    searchOpen: false,
    categories: [
      'Security',
      'Help',
      'Cash and Card',
      'Time and Date',
      'Location',
      'Emojis',
      'System Actions and Indicators',
      'Announcements',
      'Contact',
      'Financial Services',
      'Navigation',
      'User',
      'Third-Party Services',
      'Platforms',
      'Devices',
      'Controls',
    ],
  }

  componentDidMount() {
    this.rebuildIndex()
  }

  rebuildIndex = () => {
    const { index } = this.state
    const dataToSearch = new JsSearch.Search('name')

    /**
     *  defines a indexing strategy for the data
     * more about it in here https://github.com/bvaughn/js-search#configuring-the-index-strategy
     */
    dataToSearch.indexStrategy = new JsSearch.PrefixIndexStrategy()

    /**
     * defines the sanitizer for the search
     * to prevent some of the words from being excluded
     *
     */
    dataToSearch.sanitizer = new JsSearch.LowerCaseSanitizer()
    /**
     * defines the search index
     * read more in here https://github.com/bvaughn/js-search#configuring-the-search-index
     */
    dataToSearch.searchIndex = new JsSearch.TfIdfSearchIndex('slug')

    dataToSearch.addIndex('class') // sets the index attribute for the data
    dataToSearch.addIndex('uses') // sets the index attribute for the data
    dataToSearch.addIndex('category') // sets the index attribute for the data

    dataToSearch.addDocuments(index) // adds the data to be searched
    this.setState({ search: dataToSearch, isLoading: false })
  }

  searchData = e => {
    const { search } = this.state
    const queryResult = search.search(e.target.value)
    this.setState({
      searchQuery: e.target.value,
      searchResults: queryResult,
      searching: true,
    })
  }

  handleSubmit = e => {
    e.preventDefault()
  }

  noSearch = e => {
    setTimeout(() => this.setState({ searching: false }), 200)
  }

  /* Turns on the search results */
  openSearch = e => {
    this.setState({ searching: true })
  }

  /* Toggles search box */
  startSearch = e => {
    this.setState(prevState => ({
      searchOpen: !prevState.searchOpen,
    }))
  }

  render() {
    const { index, searchResults, searchQuery } = this.state
    const queryResults = searchQuery === '' ? index : searchResults
    return (
      <div>
        <div className="icon-search">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
          >
            <path
              fill="#767676"
              d="M10,1 C14.9705627,1 19,5.02943725 19,10 C19,12.124779 18.2636898,14.0775836 17.0323074,15.6171757 L22.7279221,21.3137085 C23.1184464,21.7042328 23.1184464,22.3373978 22.7279221,22.7279221 C22.3373978,23.1184464 21.7042328,23.1184464 21.3137085,22.7279221 L15.6171757,17.0323074 C14.0775836,18.2636898 12.124779,19 10,19 C5.02943725,19 1,14.9705627 1,10 C1,5.02943725 5.02943725,1 10,1 Z M10,3 C6.13400675,3 3,6.13400675 3,10 C3,13.8659932 6.13400675,17 10,17 C13.8659932,17 17,13.8659932 17,10 C17,6.13400675 13.8659932,3 10,3 Z"
            />
          </svg>
          <input
            className="icon-search__input"
            placeholder="Search for icons"
            value={searchQuery}
            onBlur={this.searchData}
          />
          <select class="icon-search__select" onBlur={this.searchData}>
            <option value="">Select</option>
            {this.state.categories.map(category => (
              <option value={category}>{category}</option>
            ))}
          </select>
        </div>
        <div className="icon-gallery">
          {this.state.categories.map(icons => (
            <div>
              {queryResults.filter(e => e.category === icons).length > 0 && (
                <div>
                  <SectionTitle color="black">{icons}</SectionTitle>
                  <div className="icon-page">
                    {queryResults
                      .filter(e => e.category === icons)
                      .map(icon => (
                        <div className="icon-block">
                          <div class="icon-block__options">
                            <a
                              href={`/iconography/${data.site}/${icon.class}.svg`}
                              download
                              className="icon-block__download"
                            >
                              <img
                                src={downloadIcon}
                                alt="Download icon button"
                              />
                              <div className="icon-block__description">
                                Download SVG
                              </div>
                            </a>
                            <CopyToClipboard
                              text={`<i class='icon icon--${icon.class}'></i>`}
                            >
                              <div className="icon-block__copy">
                                <img src={codeIcon} alt="Copy code button" />
                                <div className="icon-block__description">
                                  Copy HTML
                                </div>
                              </div>
                            </CopyToClipboard>
                          </div>
                          <i class={`icon icon--setup icon--${icon.class}`}></i>
                          <div className="icon-block__name">
                            <Highlighter
                              highlightClassName="search__highlight"
                              searchWords={[this.state.searchQuery]}
                              autoEscape={true}
                              textToHighlight={icon.name}
                            />
                          </div>

                          <div className="icon-block__uses">
                            <Highlighter
                              highlightClassName="search__highlight"
                              searchWords={[this.state.searchQuery]}
                              autoEscape={true}
                              textToHighlight={icon.uses}
                            />
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    )
  }
}

export default Iconography
